<div *ngIf="isSelected">
  <ng-container *ngIf="stepLabel">
    <ng-container *ngTemplateOutlet="stepLabel.templateRef"></ng-container>
  </ng-container>

  <div>
    <ng-content></ng-content>
  </div>
</div>
